<template>
    <div fluid class="px-6 ">
      <h3 class="pt-4">View Reported Questions</h3>
        <div class="d-flex align-center mb-4">
            <div class="flex-grow-1">
                <div class="text-h6 pr-1 ml-auto"></div>
            </div>
            <div
          class=" mx-0 d-flex align-center justify-end"
          >
          <v-card width="326px" class="elevation-0 transparent">
            <v-text-field
              solo
              label="Search here..."
              hide-details
              prepend-inner-icon="mdi-magnify"
              v-model="search"
              class="search-bar search-bar2 border-button rounded-pill mx-2"
              dense
              clearable
            ></v-text-field>
          </v-card>
           <v-btn
            class="btn outline-btn mx-2"
            outlined
            rounded
            ><v-icon>mdi-import mdi-rotate-90</v-icon></v-btn
          >
          <v-btn
            @click="filterDialog = true;"
            dense
            rounded
            class="btn outline-btn elevation-0 mx-2 pl-4 pr-6"
            ><v-icon class="pr-2">mdi-tune</v-icon>
            
            <span>Filter</span>
          </v-btn>  
            </div>
        </div>
        <div>
        <v-data-table
        fixed-header
        height="calc(100vh - 262px)"
        :loading="isLoading"
        
        :headers="headers"
        :items="questions"
        
        item-key="questionId"
        :options.sync="options"
        :footer-props="{
          itemsPerPageOptions: [10, 25, 50, 100],
        }"
        :server-items-length="count"
        class="cursor usertable rounded-table"
      >
        <template v-slot:loading>
          <bubble-loader/>
        </template>
        <template v-slot:no-data>
          <div class="custom-no-data" style="height: 160px;">
            <p>No Data Available</p>
          </div>
        </template>
        <template v-slot:[`item.fullname`]="{ item }">
          {{ item.personalInfo?.firstName + " " + item.personalInfo?.lastName | capitalizeFirst }}
        </template>
    
      </v-data-table>
      <div   class="mt-2 d-flex align-center justify-end">
        <v-btn
            @click="$emit('close')"
            dense
            rounded
            class="btn outline-btn elevation-0 mx-2 pl-4 pr-6"
            >
            <span>Close</span>
          </v-btn>  
      </div>
        
        </div>
    </div>
    
</template>
<script>
import BubbleLoader from '@/components/BubbleLoader.vue';
import UserNavMenu from "@/components/UserNavMenu.vue";
export default {
    components: {
      BubbleLoader,
      UserNavMenu
    },
    data() {
      return {
        preloader :false,
        search: "",
        filterDialog:false,
        headers: [
        { text: "Question ID", value: "questionId", cellClass: "w-15", sortable: false  },
        { text: "Question", value: "questionStatement", cellClass: "w-15 text-lowercase", sortable: false  },
        { text: "Type", value: "type", cellClass: "w-15", sortable: false  },
        { text: "Difficulty", value: "difficulty", cellClass: "w-15", sortable: false},
        { text: "Assessment", value: "assessmentName", cellClass: "w-15", sortable: false},
        {
          text: "Campaign",
          value: "campaign",
          cellClass: "w-15",
          sortable: false,
        },
        { text: "Actions", value: "actions", cellClass: "w-15", sortable: false},
        ],
        singleSelect: false,
        selected: [],
        questions:[
        {
            questionId:"12",
            questionStatement:"sdnbcmnb",
            type:"nzbcn",
            difficulty:"hard",
            assessmentName:"Test",
            campaign:"Campaign 1",
            action:"view"
        }
        ],
        options: {},
        isLoading:false,
      }
    }

}
</script>
<style>
.pad-left {
  padding-left: 80px;
}

</style>
